import styled from '@emotion/styled';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import React, { Fragment, useState } from 'react';
import { BsChevronDown, BsChevronUp, BsEye } from 'react-icons/bs';
import { BootstrapToolTip } from '../../../../../_elements/ToolTip';
import { ActionStyles } from '../../../reusableStyles';
import { timeConvert } from '../../../../../_helpers';
import { statusData } from '../Label/_colorData';
import VisitRow, { ActionTD } from '../VisitRow';

const PillBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.6rem;
    background: #f5f5f5;
    border-radius: 100px;
    margin-left: 0.5rem;
    color: #111;
    cursor: default;
    font-weight: 600;
    font-size: 12px;
    line-height: 1;
`;

function CombinedVisitRow({
    group,
    labels,
    handleShow,
    setVerifyVisitsId,
    clientRooms,
    isTeamSettings,
    team,
    provider,
    teamDetails,
    visitVerifyMode,
    isPayroll,
    onView,
}) {
    const summary = group?.summary || {};
    const [isExpanded, setIsExpanded] = useState(false);
    const statusLabel = summary?.status === 'multiple' ? 'multiple' : summary?.status?.replaceAll('_', ' ');
    const statusColor =
        summary?.status === 'multiple' ? '#7a7a7a' : statusData[summary?.status] || statusData?.complete || '#7a7a7a';
    const colSpan = isPayroll ? 9 : 10;

    return (
        <Fragment>
            <tr
                className={`combined-parent ${summary?.label ? summary.label : ''}`}
                css={css`
                    background: ${summary?.label ? labels?.[summary?.label] : ''};

                    td:first-of-type {
                        position: relative;
                        padding-left: 6px;
                    }

                    td:first-of-type::before {
                        content: '○';
                        position: absolute;
                        left: -10px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #ffffff;
                        font-size: 18px;
                        line-height: 1;
                    }

                    ${isExpanded
                        ? `
                        td {
                            border-top: 2px dashed #ccc;
                        }
                        td:first-of-type {
                            border-left: 2px dashed #ccc;
                        }
                        td:last-of-type {
                            border-right: 2px dashed #ccc;
                        }
                    `
                        : ''}
                `}
            >
                <td>{summary?.clientName}</td>
                <td>{summary?.providerName}</td>
                <td>{summary?.employeeName}</td>
                <td>{dayjs(summary?.earliestStart).format('MM-DD-YYYY, h:mm A')}</td>
                <td>{dayjs(summary?.latestEnd).format('MM-DD-YYYY, h:mm A')}</td>
                <td
                    css={css`
                        white-space: nowrap;
                    `}
                >
                    <span
                        css={css`
                            display: inline-flex;
                            align-items: center;
                            gap: 0.5rem;
                        `}
                    >
                        {timeConvert((summary?.totalMinutes || 0) * 60)}
                        <PillBadge>Combined ({summary?.visitCount || 0})</PillBadge>
                    </span>
                </td>
                <td>{timeConvert((summary?.totalBillableMinutes || 0) * 60)}</td>
                <td>
                    <input
                        css={css`
                            width: 20px;
                            height: 20px;
                        `}
                        type="checkbox"
                        checked={false}
                        readOnly
                        disabled
                    />
                </td>
                <td>
                    <span
                        className="badge badge-sm"
                        css={css`
                            background: ${statusColor};
                            color: white;
                            font-size: 12px !important;
                        `}
                    >
                        {statusLabel || 'complete'}
                    </span>
                </td>

                <ActionTD className="action d-flex flex-row">
                    <BootstrapToolTip
                        text="View Combined Visits"
                        side="left"
                        cssStyles="top:-95% !important; min-width: 160px !important; left: -40px !important;"
                    >
                        <ActionStyles className="view-icon">
                            <BsEye
                                className="icon"
                                onClick={() => {
                                    setIsExpanded(true);
                                    onView(group);
                                }}
                            />
                        </ActionStyles>
                    </BootstrapToolTip>
                    <BootstrapToolTip
                        text={isExpanded ? 'Collapse Combined Visits' : 'Expand Combined Visits'}
                        side="left"
                    >
                        <ActionStyles className="view-icon" onClick={() => setIsExpanded((prev) => !prev)}>
                            {isExpanded ? <BsChevronUp className="icon" /> : <BsChevronDown className="icon" />}
                        </ActionStyles>
                    </BootstrapToolTip>
                </ActionTD>
            </tr>
            {isExpanded && (
                <tr>
                    <td colSpan={colSpan} className="p-0">
                        <div
                            css={css`
                                border-left: 2px dashed #ccc;
                                border-right: 2px dashed #ccc;
                                border-bottom: 2px dashed #ccc;
                                margin-bottom: 1rem;
                                background: rgba(255, 255, 255, 0.2);
                                padding: 8px 12px;

                                table tbody tr td:first-of-type {
                                    position: relative;
                                    overflow: visible;
                                    padding-left: 6px;
                                }

                                // table tbody tr td:first-of-type::before {
                                //     content: '‣';
                                //     position: absolute;
                                //     left: -10px;
                                //     top: 50%;
                                //     transform: translateY(-50%);
                                //     color: #000000;
                                //     font-size: 16px;
                                //     line-height: 1;
                                // }
                            `}
                        >
                            <table className="w-100">
                                <tbody>
                                    {(group?.visits || []).map((visit, index) => (
                                        <VisitRow
                                            key={`combined-${group?.key || 'group'}-${visit?._id || visit?.id || index}`}
                                            labels={labels}
                                            visit={visit}
                                            handleShow={handleShow}
                                            setVerifyVisitsId={setVerifyVisitsId}
                                            clientRooms={clientRooms}
                                            isTeamSettings={isTeamSettings}
                                            team={team}
                                            provider={provider}
                                            teamDetails={teamDetails}
                                            visitVerifyMode={visitVerifyMode}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            )}
        </Fragment>
    );
}

export default CombinedVisitRow;
